var _circle, _circle2, _circle3, _circle4, _circle5, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFuelingCompleted = function SvgFuelingCompleted(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62,
    fill: "#fee658"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62,
    fill: "url(#a)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62,
    stroke: "#fff",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    width: 120,
    height: 120,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 60,
    fill: "#baef6d"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 60,
    fill: "url(#b)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e2e2e2",
    d: "M56.1734 82.2622h33.913c0 13.5483 2.8822 18.8098 7.1445 24.3648 4.7651 6.211 9.8121 12.788 9.8121 31.722H52.2603c0-18.934-.8523-25.511 3.9131-31.722 4.2624-5.555 0-10.8166 0-24.3648M58.7832 39.2158h31.3043v43.0435H58.7832z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.9131 82.2622h20.8695c0 13.5483 2.8821 18.8098 7.1445 24.3648 4.7654 6.211 9.812 12.788 9.812 31.722H20.9565c0-18.934 5.0467-25.511 9.8121-31.722 4.2623-5.555 7.1445-10.8166 7.1445-24.3648M37.9131 39.2158h20.8696v43.0435H37.9131z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6a6a",
    d: "M65.3037 69.2158h22.1739v35.2172H65.3037z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    d: "M70.522 69.2158h11.7391v7.8261c0 1.4407-1.168 2.6087-2.6087 2.6087h-6.5217c-1.4408 0-2.6087-1.168-2.6087-2.6087z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#acacac",
    d: "M65.3037 69.2158h18.2609v-30H65.3037z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7b7b7b",
    d: "m65.3037 50.9565 18.2609-2.6087v-9.1304H65.3037z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    fillRule: "evenodd",
    d: "M47.6953 109.325V39.2158h2.6087v70.1092c0 4.862 3.9419 8.804 8.8044 8.804s8.8043-3.942 8.8043-8.804v-13.37h2.6087v13.37c0 6.303-5.1098 11.413-11.413 11.413-6.3033 0-11.4131-5.11-11.4131-11.413",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0024",
    d: "M70.5211 84.8696v11.7391h-5.2174v-7.1739l3.2609-3.9131-3.2609-3.913V79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff6a6a",
    d: "M30.0869 27.4773c0-1.4407 1.168-2.6086 2.6087-2.6086h62.6087c1.4407 0 2.6087 1.1679 2.6087 2.6086v11.7392c0 1.4407-1.168 2.6087-2.6087 2.6087H32.6956c-1.4407 0-2.6087-1.168-2.6087-2.6087z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 4,
    x2: 124,
    y1: 4,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbe6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdb4d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 4,
    x2: 124,
    y1: 4,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3e075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ca83f",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFuelingCompleted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "fueling-completed.d6df016a6fb35a8b771b3286ebbcfc7b.svg";